import Filters from './Filters';

const els = document.querySelectorAll('.js-filters');

for (let el of els) {
    new Filters(el);
}
